/**
 * @(#)2020/02/27.
 * 展示型icon组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import "./index.less";
import React from "react";
import Config from "../../../config";
import { get } from "../../../utils";
import { Icon as AntdIcon } from "antd";
import { YxComponent, Connection } from "../../YxComponent";
import { omit } from "lodash";
import propTypes from "prop-types";
const IconFont = AntdIcon.createFromIconfontCN({
  scriptUrl: Config.iconFontUrls.yxWidget,
});

/*
 * YxIcon
 * @param children {reactNode} 子节点
 * @return {ReactNode}
 * */
const defulatProps = function () {
  return {
    children: "",
    type: "", // icon的值
    iconfont: false,
  };
};

@Connection(defulatProps)
class Icon extends YxComponent {
  get type() {
    const list = get(this.props, ["type", "children"], null);
    return list.find((item) => item) || "info";
  }

  render() {
    const className = [get(this.props, "className", ""), "yx_text_icon"];
    let isFontIcon = get(this.props, "iconfont", false);
    let getProps = omit(this.props, ["iconfont", "styleParam", "icoParam"]);
    if (isFontIcon) {
      className.push("yx_text_icon_iconfont");
      return <IconFont {...getProps} className={className.join(" ")} />;
    }
    return <AntdIcon {...getProps} className={className.join(" ")} />;
  }
}
export default Icon;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Icon/Icon.js